import React from "react";
import { Link } from "react-router-dom";

const DashboardItem = (props) => {
    return (
        <Link
            to={props.path}
            className='just m-2 flex cursor-pointer content-center rounded-md bg-main-600 p-2 text-white'
        >
            <span className='mr-2 flex items-center'>{props.icon} </span> {props.type}
        </Link>
    );
};

export default DashboardItem;
